// extracted by mini-css-extract-plugin
module.exports = {"caretIconButton":"CaretInputIcon_caretIconButton__CFt6U","openedCaretIconButton":"CaretInputIcon_openedCaretIconButton__xrU_c"};